const STORAGE_KEY = 'lp_feature_flags';

export enum FeatureFlag {
  PLAN_PURCHASE_OPTION = 'PLAN_PURCHASE_OPTION',
  LIGHT_FLIP = 'LIGHT_FLIP'
}

function readFeatureFlags(): Partial<Record<FeatureFlag, boolean>> {
  const raw_flags = localStorage.getItem(STORAGE_KEY);

  if (raw_flags === null) {
    return {};
  }

  try {
    const parsedFlags = JSON.parse(raw_flags);

    return parsedFlags as Record<FeatureFlag, boolean>;
  } catch {
    return {};
  }
}

export function isFeatureEnabled(flag: FeatureFlag): boolean {
  /* The contract purchase option is live for everyone, so it is no longer
   * gated on the persisted flag value. */
  if (flag === FeatureFlag.PLAN_PURCHASE_OPTION) {
    return true;
  }

  const flags = readFeatureFlags();

  return flags[flag] === true;
}

export function setFeatureFlag(flag: FeatureFlag, enabled: boolean): void {
  const flags = readFeatureFlags();

  flags[flag] = enabled;

  const serializedFlags = JSON.stringify(flags);

  localStorage.setItem(STORAGE_KEY, serializedFlags);
}
